import { render } from "./PaymentStatistics.vue?vue&type=template&id=52bc6802&scoped=true"
import script from "./PaymentStatistics.vue?vue&type=script&lang=js"
export * from "./PaymentStatistics.vue?vue&type=script&lang=js"

import "./PaymentStatistics.vue?vue&type=style&index=0&id=52bc6802&scoped=true&lang=css"

import exportComponent from "C:\\Com\\officialServe-vue\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bc6802"]])

export default __exports__